const getOMIMData = (state) =>
  state && state.variantResult && state.variantResult.omim;

const getOMIMGeneData = (state) => {
  return __IS_COMPONENTS_PORTAL__
    ? state?.variantResult?.genes?.[state.selectedGeneIndexClinical]?.omim
    : state?.variantResult?.omim;
};

export { getOMIMData, getOMIMGeneData };
